import {
  minLength, maxLength, required, email,
} from 'vuelidate/lib/validators';
import isValidString from './validationMethods';

const requiredIfPassengerUser = (value, employee) => {
  if (employee.role !== 'passenger') return true;
  return required(value);
};

export default {
  employee: {
    givenName: {
      maxLength: maxLength(255),
      required,
      isValidString,
    },
    familyName: {
      maxLength: maxLength(255),
      required,
      isValidString,
    },
    role: {
      minLength: minLength(2),
      required,
      isValidString,
    },
    email: {
      minLength: minLength(3),
      requiredIfPassengerUser,
      email,
    },
  },
  phoneNumber: {
    required,
    minLength: minLength(10),
  },
};
